import { useEffect, useState } from "react";
import { Crosshair, Factory, Wrench, Timer } from "lucide-react";
import { useLang } from "../../i18n/LangContext";
import { Section } from "../site/Primitives";
import { Matching } from "./Matching";
import { ProGate } from "./ProGate";

const TABS = [["matching", Crosshair], ["client", Factory], ["expert", Wrench], ["timer", Timer]];

export const ProSpace = () => {
  const { t } = useLang();
  const [tab, setTab] = useState("matching");

  useEffect(() => {
    const onTab = (e) => setTab(e.detail.tab);
    window.addEventListener("indushub:tab", onTab);
    return () => window.removeEventListener("indushub:tab", onTab);
  }, []);

  const onKey = (e, i) => {
    if (e.key !== "ArrowRight" && e.key !== "ArrowLeft") return;
    const next = TABS[(i + (e.key === "ArrowRight" ? 1 : TABS.length - 1)) % TABS.length][0];
    setTab(next);
    document.getElementById(`tab-${next}`)?.focus();
  };

  return (
    <Section id="espace" eyebrow={t.pro.eyebrow} title={t.pro.title} desc={t.pro.desc} testid="pro-space-section">
      <div className="tabs" role="tablist" aria-label={t.pro.eyebrow}>
        {TABS.map(([k, Icon], i) => (
          <button
            key={k} id={`tab-${k}`} type="button" role="tab" className="tab-btn" aria-selected={tab === k}
            aria-controls={`panel-${k}`} tabIndex={tab === k ? 0 : -1} onClick={() => setTab(k)} onKeyDown={(e) => onKey(e, i)}
            data-testid={`pro-tab-${k}`}
          >
            <Icon aria-hidden="true" />{t.pro.tabs[k]}
          </button>
        ))}
      </div>
      <div className="tab-panel" role="tabpanel" id={`panel-${tab}`} aria-labelledby={`tab-${tab}`} key={tab}>
        {tab === "matching" && <Matching />}
        {tab !== "matching" && <ProGate tab={tab} />}
      </div>
    </Section>
  );
};
